import React from 'react';
import cn from 'classnames';
import { urlSearchParams } from "@utility/utills";
import { LABEL } from "../../../veriables";
import { ReactComponent as SuccessIcon } from '@assets/images/check_circle.svg';
import { FormatLoyaltyPhoneNumber } from '@utility/helperFunction';

const DetailLoyaltyOffers = ({
  serverAppTheme,
  tableData,
  getLoyaltyOfferState
}) => {

    const checkLoyalty = () => {
    let loyalty = null;
    loyalty = tableData?.paymentCheck?.loyalty ?? null;
    return loyalty;
  };

  const checkOffer = () => {
    let offers = null;
    offers = tableData?.paymentCheck?.offers ?? null;
    return offers;
  };

  const seatData = JSON.parse(window.sessionStorage.getItem('seat'));
    // const displayCoupon = seatData?.paymentCheck?.offer?.isCoupon;
   const displayCoupon =
  seatData?.paymentCheck?.offer == null &&
  (seatData?.paymentCheck?.offers?.some(
    offer => offer?.isCoupon === true
  ) ?? false);
   const orderLoyalty = seatData.paymentCheck?.loyalty?.saved;

  return (
    <>
      {["22", "33"].includes(urlSearchParams("screenType")) && (
        <div
          className="my-0"
          style={{
                height:
                  getLoyaltyOfferState() === 2
                    ? "98px"
                    : getLoyaltyOfferState() === 1
                      ? "50px"
                      : "0px",
                overflowY: "auto"
              }}
        >
          {checkLoyalty() && orderLoyalty && (
            <div
              className={cn(
                "col-12 row mx-0 mt-1 py-2 w-100 align-content-center fs_18 fw-500 d-flex justify-content-between",
              )}
              style={{
                background: serverAppTheme?.itemsBg,
                borderRadius: "4px",
                color: serverAppTheme?.primary_text,
                paddingLeft: "65px",
              }}
            >
              <div className="d-flex justify-content-start">
                {LABEL().RS_LOYALTY} ({FormatLoyaltyPhoneNumber(checkLoyalty()?.displayAccountNumber)})
              </div>
              <div className="d-flex justify-content-end"><SuccessIcon /></div>
            </div>
          )}

          {Array.isArray(checkOffer()) && checkOffer().length > 0 &&
            checkOffer().map((offer, index) => (
              <>
              {offer?.name &&
              <div
                key={index}
                className={cn(
                  "col-12 row mx-0 mt-1 py-2 w-100 align-content-center fs_18 fw-500 d-flex justify-content-between"
                )}
                style={{
                  background: serverAppTheme?.itemsBg,
                  borderRadius: "4px",
                  color: serverAppTheme?.primary_text,
                  paddingLeft: "65px",
                }}
              >
                <div className="d-flex justify-content-start">
                  {offer?.name}
                </div>
                <div className="d-flex justify-content-end">
                  <SuccessIcon />
                </div>
              </div>}
              </>
            ))
          }

          {displayCoupon && (
            <div
              className={cn(
                "col-12 row mx-0 mt-1 py-2 w-100 align-content-center fs_18 fw-500 d-flex pl-75 justify-content-between"
              )}
              style={{
                background: serverAppTheme?.itemsBg,
                borderRadius: "4px",
                color: serverAppTheme?.primary_text
              }}
            >
              <div className="d-flex justify-content-start">
                {seatData?.paymentCheck?.offers?.name
                  ? seatData?.paymentCheck?.offer?.name
                  : LABEL().RECEIPT_COUPON_KEY}
              </div>
              <div className="d-flex justify-content-end"><SuccessIcon /></div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default DetailLoyaltyOffers;